<template>
  <div>
    <el-popover trigger="contextmenu">
      <template #reference>
        <div class="msg_context_reference">
          <slot />
        </div>
      </template>
      <template #default>
        <div v-if="msgItem.isme" class="contextmenu_container">
          <p class="contextmenu_item" @click="handlRevocationMsg">撤回</p>
        </div>
      </template>
    </el-popover>

    <div
      style="clear: both; text-align: center; color: #aaa; font-size: 10px; padding-top: 5px">
      <p v-if="msgItem.is_delete == 1">已删除</p>
      <p v-if="msgItem.is_delete == 2">已撤回</p>
    </div>
  </div>
</template>

<script>
import { revocationMsg } from "@/api/chatapi";

export default {
  name: "MsgContextBody",
  props: {
    msgItem: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const handlRevocationMsg = () => {
      revocationMsg({ id: props.msgItem.id });
    };

    return { handlRevocationMsg };
  },
};
</script>
